/**
 * IS THIS CONSIGNEE CODE ONE THAT APPOINTMENTS ACTUALLY USE? (#328)
 *
 * ---- ⛔⛔ WHY THREE LINES OF CODE GET THEIR OWN MODULE AND THEIR OWN TEST ---
 *
 * ⚠️ THE ONLY WAY THIS COMPARISON CAN BE WRONG IS BY BEING MADE *FRIENDLIER*.
 * Somebody will eventually notice that `hell-aur-01` does not match
 * `HELL-AUR-01` and add a `.toLowerCase()`, because that reads like a bug and
 * the fix looks obvious.
 *
 * ⛔ IT IS NOT A BUG. `dock.Consignee.ConsigneeCode` joins to
 * `dock.AppointmentConsignee.ConsigneeCode` in SQL, and that join does no case
 * folding. Case-folding HERE would make the screen say **"Matches a code used on
 * appointments"** about a code that will never join to anything — turning the one
 * control that exists to expose a silent mismatch into a control that CONFIRMS
 * one. That is strictly worse than not having built it.
 *
 * ⭐ SO THE RULE LIVES SOMEWHERE A GUARD CAN SEE IT, with a test that fails
 * loudly the moment the comparison gets kind.
 *
 * ---- ⚠️ TRIMMING IS DIFFERENT, AND IS ALLOWED ------------------------------
 *
 * `.trim()` is applied to the TYPED value only, and only because the save path
 * trims it too — so what is compared is exactly what would be stored. ⛔ The
 * stored codes are NOT trimmed here: if an appointment genuinely carries a
 * trailing space, that is the code, and pretending otherwise would hide it.
 */

export interface KnownCode {
    consigneeCode: string;
    inAddressBook: boolean;
}

/**
 * ⛔ `===` AND NOTHING ELSE. See the module note before "improving" this.
 * @param typed what is in the input box, as typed
 * @param known the codes seen on appointments, exactly as stored
 */
export function codeIsKnown(typed: string, known: readonly KnownCode[]): boolean {
    const t = typed.trim();
    if (t.length === 0) return false;
    return known.some(k => k.consigneeCode === t);
}

/**
 * The codes appointments use that the address book does not have.
 *
 * ⭐ THESE ARE THE LOADS THAT CANNOT BE SENT A PIN, which is why they are shown
 * as an action rather than a statistic.
 */
export function codesMissingFromAddressBook<T extends KnownCode>(known: readonly T[]): T[] {
    return known.filter(k => !k.inAddressBook);
}
